import { ClientCustomCalendarModel } from '../../../../models';
import { getEndMonthDate } from '../../../../util';
import { getCustomCalendarPeriodEndDate } from '../../../../util/customCalendarPeriods';
import { ReportSettingSubleaseState } from '../Sublease';

export const getReportEndDateSublease = (
  reportSettingState: ReportSettingSubleaseState,
  customCalendarSettings: ClientCustomCalendarModel,
): Date => {
  const { endDate } = reportSettingState;

  // if custom calendar client, do not get last day of month, use endDate as is
  if (customCalendarSettings.isCustomCalendarEnabled) {
    return getCustomCalendarPeriodEndDate(endDate, customCalendarSettings);
  }

  return getEndMonthDate(endDate);
};
